var map = {
	"./Base": 726,
	"./Base/": 726,
	"./Base/index": 726,
	"./Base/index.js": 726,
	"./Base/style": 177,
	"./Base/style.js": 177,
	"./Clutch": 427,
	"./Clutch/": 427,
	"./Clutch/index": 427,
	"./Clutch/index.js": 427,
	"./Clutch/renderComponent": 1633,
	"./Clutch/renderComponent.js": 1633,
	"./Clutch/style": 1290,
	"./Clutch/style.js": 1290,
	"./NewUi": 1011,
	"./NewUi/": 1011,
	"./NewUi/index": 1011,
	"./NewUi/index.js": 1011,
	"./NewUi/style": 1291,
	"./NewUi/style.js": 1291,
	"./OldUi": 1012,
	"./OldUi/": 1012,
	"./OldUi/index": 1012,
	"./OldUi/index.js": 1012,
	"./OldUi/renderComponent": 1634,
	"./OldUi/renderComponent.js": 1634,
	"./OldUi/style": 1292,
	"./OldUi/style.js": 1292,
	"./SpireonNew": 1013,
	"./SpireonNew/": 1013,
	"./SpireonNew/index": 1013,
	"./SpireonNew/index.js": 1013,
	"./SpireonNew/renderComponent": 1635,
	"./SpireonNew/renderComponent.js": 1635,
	"./SpireonNew/style": 1293,
	"./SpireonNew/style.js": 1293,
	"./SpireonOld": 1014,
	"./SpireonOld/": 1014,
	"./SpireonOld/index": 1014,
	"./SpireonOld/index.js": 1014,
	"./SpireonOld/renderComponent": 1636,
	"./SpireonOld/renderComponent.js": 1636,
	"./SpireonOld/style": 1294,
	"./SpireonOld/style.js": 1294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;